export const FETCH_USERS_STARTED = 'FETCH_USERS_STARTED' as const;
export const FETCH_USERS_FULFILLED = 'FETCH_USERS_FULFILLED' as const;

export const fetchUsers = (data: unknown) => ({ type: FETCH_USERS_STARTED, payload: data });
export const fetchUsersFulfilled = (data: unknown) => ({
  type: FETCH_USERS_FULFILLED,
  payload: data,
});
